<div>
    <img src="./assets/images/mshop_logo.png" alt="">
</div>